import { filterIdsQuery } from "@/helpers/crmMultiFilters";
import {
  LEAD_CAMPAIGN_TYPES,
  normalizeLeadCampaignType,
} from "@/enums/leadCampaignType";
export const SALE_REPORT_FIELDS = [
  "SaleStartDate",
  "SaleEndDate",
  "SourceStartDate",
  "SourceEndDate",
  "LeadCampaignIds",
  "LeadCampaignType",
  "RegionId",
  "ProductBrandId",
];
export function buildCrmSaleReportQuery(source = {}, pagination = {}) {
  const query = {};
  SALE_REPORT_FIELDS.forEach((key) => {
    if (source[key] !== undefined && source[key] !== null && source[key] !== "")
      query[key] = source[key];
  });
  if (query.LeadCampaignIds)
    query.LeadCampaignIds = filterIdsQuery(query.LeadCampaignIds);
  if (query.LeadCampaignType !== undefined) {
    const type = normalizeLeadCampaignType(query.LeadCampaignType);
    if (type !== null)
      query.LeadCampaignType = LEAD_CAMPAIGN_TYPES.indexOf(type);
    else delete query.LeadCampaignType;
  }
  const account = localStorage.getItem("companyIndex");
  if (account) query.ParasutAccountId = account;
  if (pagination.page) query.Page = pagination.page;
  if (pagination.limit) query.Limit = pagination.limit;
  return query;
}
export function saleReportDay(value) {
  return value ? String(value).slice(0, 10) : "—";
}

// End dates are inclusive: the latest permitted day precedes the anniversary.
export function saleReportRangeError(source = {}) {
  const prefixes = ["Sale", "Source"].filter(
    (prefix) => source[`${prefix}StartDate`] || source[`${prefix}EndDate`]
  );
  if (!prefixes.length) return "dateRequired";
  for (const prefix of prefixes) {
    const error = reportDateRangeError(
      source[`${prefix}StartDate`],
      source[`${prefix}EndDate`]
    );
    if (error) return error;
  }
  return "";
}

function reportDateRangeError(startDate, endDate) {
  const parse = (value) => {
    if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value))
      return null;
    const date = new Date(`${value}T00:00:00Z`);
    return Number.isFinite(date.getTime()) &&
      date.toISOString().slice(0, 10) === value
      ? date
      : null;
  };
  if (!startDate || !endDate) return "dateRequired";
  const start = parse(startDate),
    end = parse(endDate);
  if (!start || !end || end < start) return "dateInvalid";
  const anniversary = new Date(start);
  anniversary.setUTCFullYear(start.getUTCFullYear() + 1);
  if (end >= anniversary) return "dateTooLong";
  return "";
}
